export default __webpack_public_path__ + "static/media/profile.06c30927.png";